import { Link } from "react-router-dom";
import { MarketingLayout } from "../components/MarketingLayout";
import GalleryCard from "../components/GalleryCard";
import { GALLERY, hasRealVideos } from "../data/gallery";

export default function Gallery() {
  const showSampleDisclaimer = !hasRealVideos();
  return (
    <MarketingLayout>
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="marquee-tag mb-4">// GALLERY</div>
        <h1 className="font-display font-black type-title-lg tracking-tighter mb-4">DEMO GALLERY.</h1>
        <p className="type-lead text-ink-muted mb-12 max-w-xl">Sample outputs showing what DemoCraft produces. Create your own in minutes.</p>
        <div className="grid md:grid-cols-3 gap-6">
          {GALLERY.map((d) => <GalleryCard key={d.id} demo={d} />)}
        </div>
        {showSampleDisclaimer && (
          <p className="text-xs text-ink-subtle mt-8">All gallery items are illustrative samples — not real customer productions.</p>
        )}
        {/* /new is behind auth, so a logged-out visitor hit a login wall from
            the only CTA on a public marketing page. Every other marketing CTA
            goes to /register. */}
        <div className="mt-8"><Link to="/register" className="brutal-btn">Create your demo</Link></div>
      </section>
    </MarketingLayout>
  );
}
